export const colors = {
    blueitLightBlue: '#02b9d9',
    blueitGreen: '#13b215',
    blueitOrange: '#ff9100',
    blueitTeal: '#3fc7ae',
    blueitPink: '#ff26c4',
    blueitError: '#ff4d4f',
    blueitPurple: '#8f56c2',
    blueitDarkGreen: '#00461d',
    blueitDarkBlue: '#09417d',
    blueitYellow: '#fff62a',
    blueitGray: '#808080',
    blueitRed: '#FF5722',
    blueitBrown: '#795548',
    blueitBlueGray: '#607D8B',
    blueitYellow2: '#ffcc00',
    blueitNavyBlue: "#09417d",
    blueitDarkGray: "#545861",
    wellWater: '#9e24c3',
    osmosisWater: '#ff26c4',
    recycleWater: '#069a6e',
    domesticWasteWater: '#ffd6cf',
    processWasteWater: '#673ab7',
    coolingWater: '#fb8c00',
    greyWater: '#808080',
    softWater: '#2bb2fe',
    coldWater: '#fb8c00',
    usageWater: '#34a0a4',
    rainWater: '#8bc34a',
    domesticWater: '#f590eb',

} as const;

export type ColorKey = keyof typeof colors;
export type ColorValue = typeof colors[ColorKey];